// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { ReactNode } from 'react'
import {
  Box,
  Flex,
  ShimmerTitle,
  Typography,
  Tag,
  TagProps,
  TabsProps,
} from '@teamnine/pcj-ui-v2'

import * as Styled from './Styles'

import Breadcrumbs, {
  BreadcrumbItem,
} from '@/app/shared/components/Breadcrumbs'

type PageHeaderTag = {
  label: string
  color?: TagProps['color']
}

type PageHeaderTabs = {
  key: string
  items: TabsProps['items']
  activeKey?: string
  onChange?: TabsProps['onChange']
}

type PageHeaderProps = {
  title: string
  action?: ReactNode
  tag?: PageHeaderTag
  breadcrumbItems?: BreadcrumbItem[]
  isLoading?: boolean
  tabs?: PageHeaderTabs
}

export default function PageHeader({
  title,
  action,
  tag,
  tabs,
  breadcrumbItems,
  isLoading,
}: PageHeaderProps) {
  return (
    <Flex direction="column" gap={24}>
      <Flex direction="column" gap={16}>
        <Flex justify="space-between" align="center">
          <Flex align="center" gap={24}>
            {isLoading ? (
              <Box w="250px">
                <ShimmerTitle line={1} variant="primary" />
              </Box>
            ) : (
              <Typography variant="header-xl">{title}</Typography>
            )}
            {tag && <Tag color={tag.color ?? 'primary'}>{tag.label}</Tag>}
          </Flex>
          {action && action}
        </Flex>
        {breadcrumbItems && (
          <Breadcrumbs items={breadcrumbItems} isLoading={isLoading} />
        )}
      </Flex>
      {tabs && (
        <Styled.Tabs
          key={tabs.key}
          items={tabs.items}
          activeKey={tabs.activeKey}
          onChange={tabs.onChange}
        />
      )}
    </Flex>
  )
}
